import { DataBean } from "../../DataBean";


export class ElectronicPayrollProperties extends DataBean {

    public async updatetElectronicPayrollProperties(args: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_updatetElectronicPayrollProperties_Number", [args]);
    }

}